import { useContext, useState, useEffect, useMemo } from 'react'

import { FronthubContext } from 'front-hub-context-api'
import Flagger from './flagger'
import { isPromise } from '../../../../core/object'

export default function useFeature() {
  const { features } = useContext(FronthubContext)
  const [availableFeatures, setAvailableFeatures] = useState(features)

  let available
  let cancel

  if (isPromise(availableFeatures)) {
    cancel = availableFeatures.then(setAvailableFeatures).cancel
  } else {
    available = Object.entries(availableFeatures).map(([_, value]) => value)
  }
  useEffect(() => cancel, [])

  const Component = Flagger({ available })
  Component.Enabled = Flagger({ available })
  Component.Disabled = Flagger({ available }, false)

  return useMemo(() => Component, [availableFeatures])
}
